import sc1stScience from "./sc1stScienceQuizContent";
import sc1stSocialStudies from "./sc1stSocialStudiesQuizContent";
import sc1stMath from "./sc1stMathQuizContent";
import sc1stOther from "./sc1stOtherQuizContent";

// 2nd Grade
import sc2ndScience from "./sc2ndScienceQuizContent";
import sc2ndSocialStudies from "./sc2ndSocialStudiesQuizContent";
import sc2ndMath from "./sc2ndMathQuizContent";
import sc2ndOther from "./sc2ndOtherQuizContent";

// 3rd Grade
import sc3rdScience from "./sc3rdScienceQuizContent";
import sc3rdSocialStudies from "./sc3rdSocialStudiesQuizContent";
import sc3rdMath from "./sc3rdMathQuizContent";
import sc3rdOther from "./sc3rdOtherQuizContent";

// 4th Grade
import sc4thScience from "./sc4thScienceQuizContent";
import sc4thSocialStudies from "./sc4thSocialStudiesQuizContent";
import sc4thMath from "./sc4thMathQuizContent";
import sc4thOther from "./sc4thOtherQuizContent";

// 5th Grade
import sc5thScience from "./sc5thScienceQuizContent";
import sc5thSocialStudies from "./sc5thSocialStudiesQuizContent";
import sc5thMath from "./sc5thMathQuizContent";
import sc5thOther from "./sc5thOtherQuizContent";
// ...import the rest as you add them

// Keep your existing keys ← these are what MapPage already uses
export const sctopicsMapBySubject = {
  // 1st Grade
  sc_1st_science: sc1stScience,
  sc_1st_socialstudies: sc1stSocialStudies,
  sc_1st_math: sc1stMath,
  sc_1st_other: sc1stOther,

  // 2nd Grade
  sc_2nd_science: sc2ndScience,
  sc_2nd_socialstudies: sc2ndSocialStudies,
  sc_2nd_math: sc2ndMath,
  sc_2nd_other: sc2ndOther,

  // 3rd Grade
  sc_3rd_science: sc3rdScience,
  sc_3rd_socialstudies: sc3rdSocialStudies,
  sc_3rd_math: sc3rdMath,
  sc_3rd_other: sc3rdOther,

  // 4th Grade
  sc_4th_science: sc4thScience,
  sc_4th_socialstudies: sc4thSocialStudies,
  sc_4th_math: sc4thMath,
  sc_4th_other: sc4thOther,

  // 5th Grade
  sc_5th_science: sc5thScience,
  sc_5th_socialstudies: sc5thSocialStudies,
  sc_5th_math: sc5thMath,
  sc_5th_other: sc5thOther,
  // ...add the rest
};
